import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useFormStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function Form() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid />
}

export default function FormGridLayout() {
  return <GridProvider store={useFormStore()}>
    <Form />
  </GridProvider>
}
